import React from "react";
import ErrorPage from "components/errors/ErrorPage";
import useProductName from "brand-customization/useProductName";
import Center from "components/common/Center";
const PageErrorOverview = ({ error, title = "Error getting data" }) => {
  const productName = useProductName();
  const description = /* @__PURE__ */ React.createElement("p", null, "We had trouble fetching some data required to build this page, so here is a picture instead.");
  return /* @__PURE__ */ React.createElement(ErrorPage, { title, description, displayPageLayout: false }, /* @__PURE__ */ React.createElement("pre", null, error.toString()), /* @__PURE__ */ React.createElement(Center, null, "Check your ", productName, " server logs for more information."));
};
export default PageErrorOverview;
